import withAuth from 'components/Auth/WithAuth'
import Dashboard from 'templates/Dashboard'

function Home() {
  return (
    <>
      <Dashboard />
    </>
  )
}

export default withAuth(Home)
